import { TFunction } from 'i18next'
import { NavigateFunction } from 'react-router-dom'
import {
    DateRangeIconPath,
    DirectionRunIconPath,
    MonetizationOnIconPath,
    RecentActorsIconPath,
    SocialIconPath,
} from 'shared/assets'
import { AccountBalanceIconPath, IdCardIcon } from 'shared/assets/icons'
import {
    ArtTrackIconPath,
    EventNoteIconPath,
    FitnessIconPath,
    FolderIconPath,
    LayersIconPath,
    LocalOfferIconPath,
    PermContactCalendarIconPath,
    SettingsIconPath,
    SocialPeopleIconPath,
    StyleIconPath,
    TrophyIconPath,
} from 'shared/assets/icons/Icons'

export const menuList = (
    ability: { can: (action: string, subject: string) => boolean },
    navigate: NavigateFunction,
    t: TFunction
) => [
    {
        id: '0',
        groupName: t('pages.dashboard'),
        isVisible: true,
        items: [
            {
                isVisible: true,
                id: 'item-0',
                label: t('pages.dashboard'),
                icon: TrophyIconPath,
                renderIcon: (isActive: boolean) => (
                    <IdCardIcon
                        size={22}
                        fill={isActive ? '#2CAAE2' : '#C3CAD9'}
                    />
                ),
                handleItemClick: () => navigate('/dashboard'),
            },
        ],
    },
    {
        id: '1',
        groupName: t('pages.competitions'),
        isVisible: ability.can('read', 'CompetitionMenu'),
        items: [
            {
                isVisible: ability.can('read', 'Competition'),
                id: 'item-1',
                label: t('pages.competitions'),
                icon: TrophyIconPath,
                handleItemClick: () => navigate('/natjecanja'),
            },
        ],
    },
    {
        id: '2',
        groupName: t('pages.recreations'),
        isVisible: ability.can('read', 'RecreationMenu'),
        items: [
            {
                isVisible: ability.can('read', 'Recreation'),
                id: 'item-2',
                label: t('pages.recreations'),
                icon: FitnessIconPath,
                handleItemClick: () => navigate('/rekreacije'),
            },
        ],
    },
    {
        id: '3',
        groupName: t('pages.management'),
        isVisible: ability.can('read', 'ManagementMenu'),
        items: [
            {
                isVisible: ability.can('read', 'Organizations'),
                id: 'item-3',
                label: t('pages.organization'),
                icon: AccountBalanceIconPath,
                handleItemClick: () => navigate('/organizacije'),
            },
            {
                isVisible: ability.can('read', 'OrganizationUnits'),
                id: 'item-4',
                label: t('pages.units'),
                icon: SocialIconPath,
                handleItemClick: () => navigate('/sastavnice'),
            },
            {
                isVisible: ability.can('read', 'Seasons'),
                id: 'item-5',
                label: t('pages.seasons'),
                icon: DateRangeIconPath,
                handleItemClick: () => navigate('/sezone'),
            },
            {
                isVisible: ability.can('read', 'Sports'),
                id: 'item-6',
                label: t('pages.sports'),
                icon: DirectionRunIconPath,
                handleItemClick: () => navigate('/sportovi'),
            },
            {
                isVisible: ability.can('read', 'Leagues'),
                id: 'item-7',
                label: t('pages.leagues'),
                icon: LayersIconPath,
                handleItemClick: () => navigate('/lige'),
            },
            {
                isVisible: ability.can('read', 'Sponsors'),
                id: 'item-8',
                label: t('pages.sponsors'),
                icon: MonetizationOnIconPath,
                handleItemClick: () => navigate('/sponzori'),
            },
            {
                isVisible: ability.can('read', 'Users'),
                id: 'item-9',
                label: t('pages.users'),
                icon: SocialPeopleIconPath,
                handleItemClick: () => navigate('/korisnici'),
            },
            {
                isVisible: ability.can('read', 'Accreditations'),
                id: 'item-10',
                label: t('pages.accreditation'),
                icon: PermContactCalendarIconPath,
                handleItemClick: () => navigate('/akreditacije'),
            },
            {
                isVisible: ability.can('read', 'RolesAndPermissions'),
                id: 'item-11',
                label: t('pages.roles-and-permissions'),
                icon: RecentActorsIconPath,
                handleItemClick: () => navigate('/roles'),
            },
            // DEV mode
            // {
            //     isVisible: ability.can('read', 'RecreationTypes'),
            //     id: 'item-12',
            //     label: t('pages.recreation-types'),
            //     icon: BodySystemIconPath,
            //     handleItemClick: () => {},
            // },
        ],
    },
    {
        id: '4',
        groupName: t('pages.cms'),
        isVisible: ability.can('read', 'CMSMenu'),
        items: [
            {
                isVisible: ability.can('read', 'Announcements'),
                id: 'item-13',
                label: t('pages.cms-publications'),
                icon: ArtTrackIconPath,
                handleItemClick: () => navigate('/cms/novosti'),
            },
            {
                isVisible: ability.can('read', 'Announcements'),
                id: 'item-22',
                label: t('pages.cms-categories'),
                icon: LocalOfferIconPath,
                handleItemClick: () => navigate('/cms/kategorije'),
            },
            {
                isVisible: ability.can('read', 'Events'),
                id: 'item-14',
                label: t('pages.cms-events'),
                icon: EventNoteIconPath,
                handleItemClick: () => navigate('/cms/dogadanja'),
            },
            {
                isVisible: ability.can('read', 'Pages'),
                id: 'item-15',
                label: t('pages.cms-pages'),
                icon: StyleIconPath,
                handleItemClick: () => navigate('/cms/stranice'),
            },
            {
                isVisible: ability.can('read', 'Documents'),
                id: 'item-16',
                label: t('pages.cms-documents'),
                icon: FolderIconPath,
                handleItemClick: () => navigate('/cms/dokumenti'),
            },
            {
                isVisible: ability.can('read', 'CmsSponsors'),
                id: 'item-17',
                label: t('pages.cms-sponsors'),
                icon: MonetizationOnIconPath,
                handleItemClick: () => navigate('/cms/sponzori'),
            },
            {
                isVisible: ability.can('read', 'CmsMembers'),
                id: 'item-19',
                label: t('pages.cms-members'),
                icon: SocialPeopleIconPath,
                handleItemClick: () => navigate('/cms/clanovi'),
            },
            {
                isVisible: ability.can('read', 'CmsInstitutions'),
                id: 'item-20',
                label: t('pages.cms-institutions'),
                icon: AccountBalanceIconPath,
                handleItemClick: () => navigate('/cms/clanice'),
            },
            {
                isVisible: ability.can('read', 'CmsCompetitionTypes'),
                id: 'item-23',
                label: t('pages.cms-competition-types'),
                icon: TrophyIconPath,
                handleItemClick: () => navigate('/cms/tipovi-natjecanja'),
            },
            {
                isVisible: ability.can('read', 'CmsSportsImages'),
                id: 'item-21',
                label: t('pages.cms-sports-images'),
                icon: DirectionRunIconPath,
                handleItemClick: () => navigate('/cms/sport'),
            },
            {
                isVisible: ability.can('read', 'Settings'),
                id: 'item-18',
                label: t('pages.cms-settings'),
                icon: SettingsIconPath,
                handleItemClick: () => navigate('/cms/postavke'),
            },
        ],
    },
]
